module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('x-header', {
    staticStyle: {
      "background-color": "#2b3033"
    },
    attrs: {
      "left-options": {
        showBack: false
      }
    }
  }, [_vm._v("\n      工单管理\n    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mui-inner-wrap"
  }, [_c('aside'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "contentBox"
    }
  }, [_c('div', {
    staticClass: "mui-content"
  }, [_c('ul', {
    staticClass: "common-list-box"
  }, _vm._l((_vm.listArrs), function(item) {
    return _c('router-link', {
      key: item.id,
      attrs: {
        "to": '/user/workorder' + '/' + item.id
      }
    }, [_c('li', {
      staticClass: "list-item"
    }, [_c('div', {
      staticClass: "item-info remark"
    }, [_c('div', {
      staticClass: "item-top"
    }, [_vm._v("\n                  编号" + _vm._s(item.id) + "\n                  "), _c('span', {
      staticClass: "item-exp"
    }, [_vm._v(_vm._s(item.type))]), _vm._v(" "), _c('span', {
      staticClass: "state-icon pull-right",
      class: {
        'state-icon-loading': item.state === '待分配', 'state-icon-dealing': item.state === '处理中', 'state-icon-success': item.state === '已答复', 'state-icon-end': item.state === '已结束'
      }
    }, [_vm._v(_vm._s(item.state))]), _vm._v(" "), _c('span', {
      staticClass: "text-primary item-time pull-right"
    }, [_vm._v(_vm._s(item.time))])]), _vm._v(" "), _c('div', {
      staticClass: "item-bottom"
    }, [_c('div', {
      staticClass: "row1"
    }, [_vm._v("\n                    问题内容摘要\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "row1 remark"
    }, [_c('span', [_vm._v(_vm._s(item.content))])])])])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "clearfix pager-wrapper"
  }, [_c('div', {
    staticClass: "pagination",
    attrs: {
      "id": "pager"
    }
  }, [_c('span', {
    staticClass: "page-button pager-prev",
    class: {
      disabled: _vm.pager.page == 1
    },
    on: {
      "click": function($event) {
        _vm.pageNum(_vm.pager.page, 'up')
      }
    }
  }, [_vm._v("上一页")]), _vm._v(" "), _c('span', {
    staticClass: "page-info"
  }), _vm._v("\n                " + _vm._s(_vm.pager.page) + "/" + _vm._s(_vm.pager.pageCount) + "\n                "), _c('span', {
    staticClass: "page-button pager-next",
    class: {
      disabled: _vm.pager.page == _vm.pager.pageCount
    },
    on: {
      "click": function($event) {
        _vm.pageNum(_vm.pager.page, "down")
      }
    }
  }, [_vm._v("下一页")])])])])])])]), _vm._v(" "), _c('c-footer', {
    attrs: {
      "status": "console"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "large-add-button"
  }, [_c('a', {
    attrs: {
      "href": "/#/user/workoradd"
    }
  }, [_c('span'), _vm._v("\n        + 提交新工单\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54ce0934","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/console/gongdan.vue
// module id = GJA5
// module chunks = 1